import React, { memo } from 'react';
import { withThemeVariant } from '../../provider/ThemeProvider';
import { Box } from '@material-ui/core/';
import logo from './jobmatch.svg';

// when exact we use width and height
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The JOBMATCH.ME logo main component
 *
 * @param {logoVariant} variant The logos variant
 * @param {logoSizes}   size    The logos size
 *
 **/

export var LogoJMM = function LogoJMM(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'text' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'responsive' : _ref$size,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100' : _ref$height,
    globalThemeVariant = _ref.globalThemeVariant,
    _ref$pointer = _ref.pointer,
    pointer = _ref$pointer === void 0 ? false : _ref$pointer;
  // Logo width defenition
  var realWidth = size === 'responsive' ? '100%' : size === 'small' ? '100' : size === 'middle' ? '200' : size;
  if (size === 'exact') {
    realWidth = "".concat(width);
  }
  return /*#__PURE__*/_jsx(Box, {
    style: {
      cursor: pointer ? 'pointer' : 'none',
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      width: '100%'
    },
    children: /*#__PURE__*/_jsx("img", {
      src: logo,
      alt: "Job Match",
      style: {
        maxWidth: realWidth,
        maxHeight: '100%'
      }
    })
  });
};
export default /*#__PURE__*/memo(withThemeVariant(LogoJMM));